<template>
    <div
        class="competence-wrapper"
    >
        <router-link
            class="title"
            :to="{ name: 'professional-skill', params: { id: competence.id } }"
        >{{competence.name}}</router-link>
        <div class="competence-content">
            <div class="competence">
                <CheckHardCompetence
                    :green="true"
                    :checked="calcGreenCheck"
                    class="firstCheck"
                    @setAcknowledge="setAcknowledge(true)"
                    v-loading.small.full="greenCheckLoading"
                />
                <CheckHardCompetence
                    :green="false"
                    :checked="calcRedCheck"
                    @setAcknowledge="setAcknowledge(false)"
                    v-loading.small.full="redCheckLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CheckHardCompetence from './CheckHardCompetence';

const trackGetters = [
    'getCompetenceLevels',
];

const trackActions = [
    'setCompetenceAcknowledge',
];

export default {
    name: 'HardCompetenceItem',
    props: {
        competence: Object,
    },
    components: {
        CheckHardCompetence,
    },
    data: () => ({
        redCheckLoading: false,
        greenCheckLoading: false,
    }),
    computed: {
        ...mapGetters('accountTrack', trackGetters),
        calcRedCheck() {
            if (this.competence.userAcknowledgment === false) {
                return true;
            } else if (this.competence.userAcknowledgment === true) {
                return false;
            } else return null;
        },
        calcGreenCheck() {
            if (this.competence.userAcknowledgment === true) {
                return true;
            } else if (this.competence.userAcknowledgment === false) {
                return false;
            } else return null;
        },
    },
    methods: {
        ...mapActions('accountTrack', trackActions),
        async setAcknowledge(val) {
            if(val) {
                this.greenCheckLoading = true;
            } else {
                this.redCheckLoading = true;
            }
            await this.setCompetenceAcknowledge({
                competenceId: this.competence.id,
                status: val,
            });
            if(val) {
                this.greenCheckLoading = false;
            } else {
                this.redCheckLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .competence-wrapper{
        width: 22px;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: center;

        .title{
            width: 129px;
            position: absolute;
            top: -77px;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            color: #4663AB;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            height: 65px;
        }
        .competence-content{
            width: 22px;
            height: 22px;

            .competence{
                padding-top: 12px;
                .firstCheck{
                    margin-bottom: 27px;
                }
            }
        }

    }
</style>